var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vuw-navigation-button vuw-pointer vuw-dynamic-bg-color-3 vuw-text-support-4",attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }